<template>
 <div class="com-bottom side-panel top mapBg osy" style="left:25%;">
    <div class="side-panel-bg p-20 mb-20">
      <div class="side-panel-content ">
        <h1 class="titleIcon f-20 c-satwo p-20"><img src="/imgs/titleicon1.png" class="mr-15">算力建设情况<img src="/imgs/titleicon.png" class="ml-10"></h1>
        <div class="fr ov comCenterIndex">
          <div v-for="(panel, index) in dataconstructBasicData" :key="index" class="f1 tc" :class="panelClasses[index]">
            <div class="f-18 pt-10">{{ panel.mainValue }}</div>
            <div class="f-18 pt-5">{{ panel.subValue }}</div>
            <div class="f-18 pt-30 c-bgyanse b">{{ panel.title }}</div>
          </div>
        </div>
        <div class="comCenterGpu mt-20">
          <chart-rosetwo :data1="datagpuProportion" :data2="datagpuProportionComput" style="height:170px;"></chart-rosetwo>
        </div>
        <div class="comCenterTxt mt-15">
          设计容量：<span class="c-satwo mr-25">{{ designCapacity }}KW</span>
          绿电占比：<span class="c-satwo mr-15">{{ greenPowerPercentage }}%</span>
          已投入设备额定能耗：<span class="c-satwo">{{ ratedPowerConsumption }}KW</span>
        </div>
      </div>
    </div>
    <div class="side-panel-bg p-20">
    <h1 class="titleIcon f-20 c-satwo">
      <img src="/imgs/titleicon1.png" class="mr-15">各数据中心建设情况<img src="/imgs/titleicon.png" class="ml-10">
    </h1>
    <div class="listModleLeft">
      <div v-for="(center, index) in datadataCenter" :key="index" class="listModleLeftContent">
        <h3 class="f-12 pt-10">{{ center.name }}</h3>
        <div class="pt-5">
          算力 <span class="c-satwo">{{ center.computingPower }}P</span>
          机架 <span class="c-satwo">{{ center.racks }}</span>
          能耗 <span class="c-satwo">{{ center.powerConsumption }}KW</span>
        </div>
        <div>
          算力节点 <span class="c-satwo">{{ center.computingNodes }}</span>
          GPU卡 <span class="c-satwo">{{ center.gpuCards }}</span>
        </div>
        <div>
          GPU卡类型：<span class="c-satwo">{{ center.gpuCardTypes }}</span>
        </div>
      </div>
    </div>
  </div>
 </div>
</template>

<script>
import chartRosetwo from './chart-rosetwo'

export default {
  name: "VideoDetail",
  components: {
    chartRosetwo,
  },
  props: ['dataconstructBasicData','datagpuProportion','datagpuProportionComput','datadataCenter'],
  data() {
    return {
      designCapacity: 40000, // 设计容量 (单位：KW)
      greenPowerPercentage: 75, // 绿电占比 (百分比)
      ratedPowerConsumption: 13824, // 已投入设备额定能耗 (单位：KW)
      // 定义面板的样式类
      panelClasses: [
        'sabgicon4 c-bgyanse4',
        'sabgicon2 c-bgyanse2',
        'sabgicon3 c-bgyanse3',
        'sabgicon1 c-bgyanse1'
      ]
    };
  },
  created() {
    //获取视频地址
    // this.request("/file/detail/" + id).then(res => {
    //    this.playerOptions.sources[0].src = res.data.url
    // })
  },
  methods: {}
}
</script>
<style scoped>
.side-panel-content{
  background: url(/imgs/saCenter_bg.png) no-repeat center;
  height: 511px;
}
.comCenterIndex{
  margin: 0 55px;
}
.titleIcon{
  font-size: 21px;
  color: #19ECFF;
  letter-spacing: 4.2px;
  line-height: 33px;
  font-weight: 500;
  text-align: center;
}
.sabgicon1{
  background: url(/imgs/sabg_bg1.png) no-repeat center;
  height: 158px;
}
.sabgicon2{
  background: url(/imgs/sabg_bg2.png) no-repeat center;
  height: 158px;
}
.sabgicon3{
  background: url(/imgs/sabg_bg3.png) no-repeat center;
  height: 158px;
}
.sabgicon4{
  background: url(/imgs/sabg_bg4.png) no-repeat center;
  height: 158px;
}
.c-bgyanse{
  color: #00342C;
}
.c-bgyanse4{
  color: #00F5DA;
}
.c-bgyanse2{
  color: #00FF88;
}
.c-bgyanse3{
  color: #AFC706;
}
.c-bgyanse1{
  color: #00ECFF;
}
.comCenterGpu{
  height:194px;
  background: url(/imgs/saCenter_gpubg.png) no-repeat center;
}
.comCenterTxt{
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}


.listModleLeft{
  overflow: hidden;
  padding-bottom: 10px;
  margin: 0 10px;
}
.listModleLeftContent{
  float: left;
  margin: 20px 24px 0 0;
  width: 48%;
  height: 125px;
  background: url(/imgs/salist-centerbg.png) no-repeat;
  background-size: 100% 100%;
  padding: 0px 0 0 30px;
}
.listModleLeftContent:nth-child(2n){
  margin-right: 0;
}
.listModleLeftContent div{
  line-height: 26px;
  font-size: 16px;
}
.listModleLeftContent div span{
  margin-right: 5px;
}

.listModleLeftContent h3{
  font-size: 14px;
}

</style>
